import { AuthLayout } from '@layout/index';

import SelectWorkspaceForm from './components/SelectWorkspaceForm';
const SelectWorkspace = () => {
  return (
    <AuthLayout>
      <div className="flex flex-col w-full gap-2 justify-center items-center">
        <div className="text-2xl font-bold">Select brand workspace</div>
        <div className="text-sm max-w-[320px] text-center text-dark-2">
          A brand workspace is where your raw material and results data are
          stored for each brand.
          <br />
          <div className="mt-2">
            Choose a global brand workspace or use the arrow for variations.
          </div>
        </div>
      </div>
      <SelectWorkspaceForm />
    </AuthLayout>
  );
};

export default SelectWorkspace;
